import { Badge } from '@/components/ui/badge.js';
import {
  CoachSessionRemarkV2,
  CoachSessionRemarkV2Completed,
  formatCoachSessionRemarkV2Label,
  SessionCompletionStatus,
  SessionZoom,
} from '@airreading/common/data';
import { Temporal } from 'temporal-polyfill';
export interface SessionCompletionStatusCellProps {
  status: SessionCompletionStatus;
  coachSessionRemarksV2?: CoachSessionRemarkV2[];
  session?: {
    zoom?: SessionZoom | null;
    startInstant?: Temporal.Instant;
    endInstant?: Temporal.Instant;
    addedCoachSessionRemarksV2?: CoachSessionRemarkV2[];
  };
  testId?: string;
}

export function SessionCompletionStatusCell({
  status,
  coachSessionRemarksV2,
  session,
  testId,
}: SessionCompletionStatusCellProps) {
  if (status === SessionCompletionStatus['In Progress']) {
    return (
      <span className="text-muted-foreground" data-testid={testId}>
        —
      </span>
    );
  }

  const isIncomplete = status === SessionCompletionStatus['Incomplete'];

  if (isIncomplete) {
    return (
      <>
        {coachSessionRemarksV2
          ?.filter((tag) => !CoachSessionRemarkV2Completed.includes(tag))
          ?.map((tag, index) => (
            <Badge
              key={tag}
              variant="outline"
              className="text-center mr-1"
              data-testid={testId && (coachSessionRemarksV2!.length === 1 ? testId : `${testId}-${index + 1}`)}
            >
              {formatCoachSessionRemarkV2Label(tag, session)}
            </Badge>
          ))}
      </>
    );
  }
  return (
    <>
      {status === SessionCompletionStatus['Completed'] && (
        <span data-testid={testId} className="mr-1">
          ✅ Completed
        </span>
      )}
      {coachSessionRemarksV2
        ?.filter((tag) => CoachSessionRemarkV2Completed.includes(tag))
        .map((tag, index) => (
          <Badge
            key={tag}
            variant="outline"
            className="text-center mr-1"
            data-testid={testId && (coachSessionRemarksV2!.length === 1 ? testId : `${testId}-${index + 1}`)}
          >
            {formatCoachSessionRemarkV2Label(tag, session)}
          </Badge>
        ))}
    </>
  );
}
